module.exports = __webpack_public_path__ + "static/media/logout.c5dafae6.svg";